import { KanbanSquare, Table2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/** Un solo apartado "Leads" (ruta /pipeline) con dos vistas: tablero (por defecto) y tabla. Los filtros viajan en la URL. */
export function ViewSwitch({
  view,
  params,
}: {
  view: 'tablero' | 'tabla';
  params: URLSearchParams;
}) {
  const to = (v: 'tablero' | 'tabla') => {
    const p = new URLSearchParams(params);
    if (v === 'tabla') p.set('vista', 'tabla');
    else p.delete('vista');
    const q = p.toString();
    return `/pipeline${q ? `?${q}` : ''}`;
  };
  return (
    <div
      role="group"
      aria-label="Vista"
      className="bg-muted inline-flex rounded-md p-0.5"
      data-testid="view-switch"
    >
      <Button asChild size="sm" variant={view === 'tablero' ? 'default' : 'ghost'} className="h-8">
        <Link to={to('tablero')} data-testid="view-board" aria-current={view === 'tablero'}>
          <KanbanSquare className="h-4 w-4" /> Tablero
        </Link>
      </Button>
      <Button asChild size="sm" variant={view === 'tabla' ? 'default' : 'ghost'} className="h-8">
        <Link to={to('tabla')} data-testid="view-table" aria-current={view === 'tabla'}>
          <Table2 className="h-4 w-4" /> Tabla
        </Link>
      </Button>
    </div>
  );
}
